import React, { useState, useEffect } from "react";
import './AllSubscription.scss';
import SvgIcon from '@Components/icons/SvgIcon';
import HomeLayout from '../layout/components/HomeLayout/HomeLayout';
import { useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "@Src/app/hooks";
import { setSubscriptionData } from "@Src/app/reducers/auth/loginSlice";
import { showSpinner } from "@Src/app/reducers/globalSlice";
import { getUserDetails } from "@Src/features/UserProfile/Services/UserProfile.sevice";
import { toast } from "react-hot-toast";
import { AppRouteURL, AppRouteURLwithChilds } from "@Constants/app-route-url.constant";
import { Dialog } from "primereact/dialog";
import ApiService from '@Services/ApiService';
import { SUBSCRIPTION_API_ROUTES } from './services/AllSubscription.api.constant';

interface SubscriptionPlan {
    Id: number;
    PlanName: string;
    Duration: number;
    SubHeading: string;
    ButtonName: string;
    Description: string;
    Uom: string;
    NumberOfMocktests: number;
    NumberOfStudents?: number;
    ShowAnalytics: number;
    Price: string;
}

export const AllSubscriptionIndex = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const isLoggedIn = useAppSelector(state => state.login.isLoggedIn);
    const studentSubPlanName = useAppSelector(state => state.login.Student_sub_PlanName);
    const studentSubEndDate = useAppSelector(state => state.login.Student_sub_EndDate) as string | null;
    const [showSubscriptionDialog, setShowSubscriptionDialog] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState<SubscriptionPlan | null>(null);
    const [subscriptionPlans, setSubscriptionPlans] = useState<SubscriptionPlan[]>([]);
    const [instituteSubcriptionPlan, setInstituteSubcriptionPlan] = useState<SubscriptionPlan>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (isLoggedIn) {
            navigate("/")
        }
        fetchSubscriptionPlans();
    }, []);

    const fetchSubscriptionPlans = async () => {
        try {
            const response = await ApiService.fetchData({
                url: SUBSCRIPTION_API_ROUTES.SUBSCRIPTION_PLAN_ALL,
                method: 'GET'
            });
            if (response.success && response.data?.student_subscription_Plan) {
                setSubscriptionPlans(response.data.student_subscription_Plan);
            }
            if (response.success && response.data?.institute_subscription_Plan) {
                setInstituteSubcriptionPlan(response.data.institute_subscription_Plan[0])
            }
        } catch (error) {
            console.error('Error fetching subscription plans:', error);
        } finally {
            setLoading(false);
        }
    };

    const formatPlanData = (plan: SubscriptionPlan, index: number) => {
        const bgClass = index === 0 ? 'light-plan' : 'premium-plan';
        const features = plan.Description;
        //  (plan === instituteSubcriptionPlan) ? [
        //     `Students - ${plan.NumberOfStudents}`,
        //     `Mocktest - ${plan.NumberOfMocktests}`,
        //     `Duration - ${plan.Duration} ${plan.Uom === 'month' ? 'Month' : plan.Uom}${plan.Duration > 1 ? 's' : ''}`
        // ] : [
        //     `Mocktest - ${plan.NumberOfMocktests}`,
        //     `Duration - ${plan.Duration} ${plan.Uom === 'month' ? 'Month' : plan.Uom}${plan.Duration > 1 ? 's' : ''}`
        // ];

        // if (plan.ShowAnalytics === 1) {
        //     features.push('Performance Analysis and Tips');
        // }

        const priceNum = parseFloat(plan.Price);
        const formattedPrice = priceNum % 1 === 0 ? priceNum.toFixed(0) : plan.Price;

        return {
            id: plan.Id.toString(),
            name: plan.PlanName,
            subHeading: (plan === instituteSubcriptionPlan) ? 'For School/Institute' : 'For Student',
            price: plan.Price === '0.00' ? 'FREE' : ((plan === instituteSubcriptionPlan) ? "For Coaching Institutes" : `₹${formattedPrice}`),
            description: plan.SubHeading,
            features,
            buttonText: plan.ButtonName,
            buttonClass: index === 0 ? 'ia-btn-outline-primary' : 'ia-btn-primary',
            bgClass,
            popular: index === 1
        };
    };

    if (loading) {
        return (
            <HomeLayout>
                <div className="subscription-page-container">
                    <div className="tw-flex tw-justify-center tw-items-center tw-h-64">
                        <div>Loading...</div>
                    </div>
                </div>
            </HomeLayout>
        );
    }

    return (
        <HomeLayout >
            <div className="subscription-page-container">
                <div className="subscription-header">
                    <h1 className="subscription-heading">Best Packages for You</h1>
                    <p className="subscription-subheading">Start Improving Your Score — Choose Your Plan</p>
                    <p className="tw-text-sm tw-text-violet-500">Get tests, insights, and practice designed to improve your performance.</p>
                    {studentSubPlanName && studentSubEndDate && (
                        <p className="tw-text-green-600 tw-font-medium tw-mt-2">
                            You already have {studentSubPlanName} plan and expiry date is {studentSubEndDate.split('-').reverse().join('-')}
                        </p>
                    )}
                </div>

                <div className="allsubscription-plans">
                    {subscriptionPlans.map((plan, index) => {
                        const formattedPlan = formatPlanData(plan, index);
                        return (
                            <div
                                key={formattedPlan.id}
                                className={`subscription-card ${formattedPlan.bgClass} ${formattedPlan.popular ? 'popular' : ''}`}
                            >
                                {/* Green checkmark for active subscription */}
                                {/* {studentSubPlanName && formattedPlan.name === studentSubPlanName && (
                                    <div className="active-plan-badge">
                                        <SvgIcon name="tick" size={40} className="active-check-icon" />
                                    </div>
                                )} */}


                                <div className="plan-header mt-3">
                                    <div className="plan-subheading">
                                        <span className='tw-shadow-lg'>{formattedPlan.subHeading}</span>
                                    </div>

                                    <h3 className="plan-name">{formattedPlan.name}</h3>

                                    <div className="plan-price">
                                        {formattedPlan.price}
                                    </div>
                                </div>

                                <p className="plan-description">{formattedPlan.description}</p>

                                <div className="plan-features">
                                    {/* {formattedPlan.features.map((feature, featureIndex) => (
                                        <div key={featureIndex} className="feature-item">
                                            <SvgIcon name="tick" size={16} className="check-icon" />
                                            <span>{feature}</span>
                                        </div>
                                    ))} */}
                                    <div className="feature-item" style={{ color: formattedPlan.popular ? "white" : "" }} dangerouslySetInnerHTML={{ __html: formattedPlan.features }}></div>
                                </div>

                                <button
                                    className={`ia-btn ${formattedPlan.buttonClass} plan-button `}
                                    onClick={() => {
                                        if (!isLoggedIn) {
                                            navigate(AppRouteURL.AUTH + AppRouteURLwithChilds.AUTH.childrens.LOGIN.path);
                                            return;
                                        }
                                        if (studentSubPlanName && studentSubEndDate) {
                                            return;
                                        }
                                        if (parseFloat(plan.Price) > 0) {
                                            navigate(AppRouteURL.CHECKOUT, { state: { plan } });
                                            return;
                                        }
                                        setSelectedPlan(plan);
                                        setShowSubscriptionDialog(true);
                                    }}
                                >
                                    {formattedPlan.buttonText}
                                </button>
                            </div>
                        );
                    })}
                    {
                        (() => {
                            const formattedPlan = formatPlanData(instituteSubcriptionPlan as SubscriptionPlan, 0);
                            return (
                                <div
                                    key={formattedPlan.id}
                                    className={`subscription-card ${formattedPlan.bgClass} ${formattedPlan.popular ? 'popular' : ''}`}
                                >
                                    {/* Green checkmark for active subscription */}
                                    {studentSubPlanName && formattedPlan.name === studentSubPlanName && (
                                        <div className="active-plan-badge">
                                            <SvgIcon name="tick" size={40} className="active-check-icon" />
                                        </div>
                                    )}


                                    <div className="plan-header mt-3">
                                        <div className="plan-subheading">
                                            <span className='tw-shadow-lg'>{formattedPlan.subHeading}</span>
                                        </div>

                                        <h3 className="plan-name">{formattedPlan.name}</h3>

                                        <div className="plan-price">
                                            {formattedPlan.price}
                                        </div>
                                    </div>

                                    <p className="plan-description">{formattedPlan.description}</p>

                                    <div className="plan-features">
                                        {/* {formattedPlan.features.map((feature, featureIndex) => (
                                            <div key={featureIndex} className="feature-item">
                                                <SvgIcon name="tick" size={16} className="check-icon" />
                                                <span>{feature}</span>
                                            </div>
                                        ))} */}
                                        <div className="feature-item" dangerouslySetInnerHTML={{ __html: formattedPlan.features }}></div>
                                    </div>

                                    <button
                                        className={`ia-btn ${formattedPlan.buttonClass} plan-button `}
                                        // disabled={!isLoggedIn || !!(studentSubPlanName && studentSubEndDate)}
                                        onClick={() => {
                                            // if (!isLoggedIn) {
                                            //     navigate(AppRouteURL.AUTH + AppRouteURLwithChilds.AUTH.childrens.LOGIN.path);
                                            //     return;
                                            // }
                                            // if (studentSubPlanName && studentSubEndDate) {
                                            //     return;
                                            // }
                                            // setSelectedPlan(instituteSubcriptionPlan as SubscriptionPlan);
                                            // setShowSubscriptionDialog(true);
                                            navigate(AppRouteURL.SUBSCRIPTIONREQUESTINSTITUTE);
                                        }}
                                    >
                                        {formattedPlan.buttonText}
                                    </button>
                                </div>
                            );
                        })()
                    }
                </div>

                {/* <div className="subscription-footer">
                <p>All plans include access to our mobile app and 24/7 customer support</p>
            </div> */}

                <Dialog
                    className="mock-test-dialog-box"
                    position="top"
                    visible={showSubscriptionDialog}
                    onHide={() => setShowSubscriptionDialog(false)}
                    closeOnEscape={false}
                >
                    <div className="pause-dialog-box">
                        <div className="p-dlg-heading">Do you want to subscribe?</div>
                        {/* <span className="p-dilg-para">Do you really want to subscribe?</span> */}

                        <div className="tw-mt-7 tw-flex gap-3 tw-justify-center">
                            <button
                                className="ia-btn ia-btn-outline-primary"
                                onClick={() => setShowSubscriptionDialog(false)}
                            >
                                No
                            </button>
                            <button
                                className="ia-btn ia-btn-primary"
                                onClick={async () => {
                                    if (selectedPlan) {
                                        try {
                                            dispatch(showSpinner(true));
                                            const subscriptionResponse = await ApiService.fetchData({
                                                url: SUBSCRIPTION_API_ROUTES.SUBSCRIBE_STUDENT_PLAN,
                                                method: 'POST',
                                                data: { PlanId: selectedPlan.Id }
                                            });

                                            if (subscriptionResponse.success) {
                                                // Call user details API to get updated subscription data
                                                const userDetailsResponse = await getUserDetails();

                                                if (userDetailsResponse.ResponseType === 'SUCCESS' && userDetailsResponse.data?.[0]) {
                                                    const userData = userDetailsResponse.data[0];

                                                    // Store subscription data in Redux
                                                    dispatch(setSubscriptionData({
                                                        last_student_subscription_rel_id: userData.last_student_subscription_rel_id,
                                                        InstituteId: userData.InstituteId,
                                                        Institutelogoimageurl: userData.Institutelogoimageurl,
                                                        LanguageId: userData.LanguageId,
                                                        Student_sub_PlanName: userData.Student_sub_PlanName,
                                                        Student_sub_NumberOfMocktests: userData.Student_sub_NumberOfMocktests,
                                                        Student_sub_ShowAnalytics: userData.Student_sub_ShowAnalytics,
                                                        Student_sub_StartDate: userData.Student_sub_StartDate,
                                                        Student_sub_EndDate: userData.Student_sub_EndDate,
                                                        Institute_sub_PlanName: userData.Institute_sub_PlanName,
                                                        Institute_sub_NumberOfMocktests: userData.Institute_sub_NumberOfMocktests,
                                                        Institute_sub_NoOfStudents: userData.Institute_sub_NoOfStudents,
                                                        Institute_sub_ShowAnalytics: userData.Institute_sub_ShowAnalytics,
                                                        Institute_sub_StartDate: userData.Institute_sub_StartDate,
                                                        Institute_sub_EndDate: userData.Institute_sub_EndDate
                                                    }));

                                                    toast.success('Subscription successful!');

                                                    // Redirect to previous URL if available
                                                    const previousUrl = localStorage.getItem('redirectAfterSubscription');
                                                    if (previousUrl) {
                                                        localStorage.removeItem('redirectAfterSubscription');
                                                        navigate(previousUrl);
                                                        return;
                                                    }
                                                }
                                            }

                                            setShowSubscriptionDialog(false);
                                        } catch (error) {
                                            console.error('Subscription error:', error);
                                            toast.error('Subscription failed. Please try again.');
                                        } finally {
                                            dispatch(showSpinner(false));
                                        }
                                    }
                                }}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </Dialog>
            </div>
        </HomeLayout>
    );
};